/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useContext, useState } from 'react'

import Button from '../Button'

import { AppContext } from '../../store'
import './style.scss'

function SectionInputCode() {
  const {
    state: { loading, contentful, promoCode, promoCodesAllowed },
    loadOffer,
  } = useContext(AppContext)
  const [code, setCode] = useState('')
  const [hasError, setHasError] = useState(false)

  function error() {
    setHasError(true)
  }

  function onCodeChange(e) {
    setHasError(false)
    setCode(e.target.value.toString().toUpperCase())
  }

  async function seeOffer() {
    if (!(promoCodesAllowed || []).includes(code.toUpperCase())) return error()

    const result = await loadOffer(code.toUpperCase())
    if (!result) error()
  }

  return (
    <>
      <section className='section-input-code'>
        <h1>Digite seu código promocional para ter acesso à oferta:</h1>
        <section className='code-input-container'>
          <div>
            <input className={`input ${hasError && 'error-input'}`} type='text' value={code} onChange={onCodeChange} />
          </div>
          <div>
            <Button
              className='secondary'
              text='VER OFERTA'
              onClick={seeOffer}
              disabled={!code.length || loading || hasError}
            />
          </div>
        </section>
        <div className='no-cupom'>
          <a href='#' onClick={() => loadOffer(promoCode.replace('HUB-', ''))}>
            Não tenho cupom promocional
          </a>
        </div>
        {!loading && hasError && <p className='error-text'>O código informado é inválido, tente outro código.</p>}
      </section>
    </>
  )
}

export default memo(SectionInputCode)
